function handleEscapeKey(handler) {
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      handler(); // Gọi hàm handler khi nhấn phím Escape
    }
  };

  return {
    addListener: () => document.addEventListener("keydown", handleEscape),
    removeListener: () => document.removeEventListener("keydown", handleEscape),
  };
}

export default handleEscapeKey;
